import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const ElevioIntegrationContext = createContext({
    elevioIntegration: undefined,
});
export const useElevioIntegration = () => useContext(ElevioIntegrationContext);
export function ElevioIntegrationProvider({ elevioIntegration, children, }) {
    return (_jsx(ElevioIntegrationContext.Provider, Object.assign({ value: { elevioIntegration } }, { children: children })));
}
